import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
//变化中的组件
import HomeHeader from '@/components/MasterTop'
import CommonFooter from '@/components/MasterButtom'
import Banner from '@/components/CommonBanner'
import floatAd from '@/components/floatAd.vue'
import fixedImg from '@/components/fixedImg.vue'
import fileLoading from '@/components/fileLoading.vue'
var routes = {
	top: HomeHeader,
	footer: CommonFooter,
	banner:Banner,
	floatAd:floatAd,
	fixedImg:fixedImg,
	fileLoading:fileLoading
}
//页面
import Home from '@/pages/Home'
import Login from '@/pages/login/login.vue'
import About from '@/pages/About'
import ScriptPrePrintDetailed from '@/pages/ScriptPrePrintDetailed'
import PreprintList from '@/pages/PreprintList'
import gzhPreprintList from '@/pages/gzhPreprintList'
import DocumentList from '@/pages/DocumentList'
import comments from '@/pages/comments'
import contact from '@/pages/contact'
import AdvancedSearch from '@/pages/AdvancedSearch'
import QuickSearch from '@/pages/QuickSearch'
import digest from '@/pages/digest'
import dlistnum from '@/pages/dlistnum'
import gzhdlistnum from '@/pages/gzhdlistnum'
import DownloadlistViewlist from '@/pages/DownloadlistViewlist'
import Editorial from '@/pages/Editorial'
import Links from '@/pages/Links'
import NewsDetails from '@/pages/NewsDetails'
import gzhNewsDetails from '@/pages/gzhNewsDetails'
import NewsList from '@/pages/NewsList'
import gzhNewsList from '@/pages/gzhNewsList'
import OAList from '@/pages/OAList'
import gzhOAList from '@/pages/gzhOAList'
import Export from '@/pages/Export'
import Situation from '@/pages/Situation'
import FixedBody from '@/pages/FixedBody'
import gzhFixedBody from '@/pages/gzhFixedBody'
import Subscribe from '@/pages/Subscribe'
// import viewlist from '@/pages/viewlist'
import Nopassword from '@/pages/login/Nopassword.vue'
import LookforPassword from '@/pages/login/LookforPassword.vue'
import regist from '@/pages/regist/regist'
import FieldColumnList from '@/pages/FieldColumnList.vue'
import gzhFieldColumnList from '@/pages/gzhFieldColumnList.vue'
import Rss from '@/pages/Rss.vue'
import gzhRecommended from '@/pages/gzhRecommended.vue'
import DirectorAndFeatures from '@/pages/DirectorAndFeatures.vue'
import EamilVerification from '@/pages/EamilVerification.vue'
import ChangePassword from '@/pages/ChangePassword.vue'
//组件当中
import login_qq from '@/components/Login/Login_qq'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  	return originalPush.call(this, location).catch(err => err)
}

export default new Router({
//    mode: 'history',
  routes: [
	  {
		path: "/", //首页
		name: "author-index",
		components: {
		  default: Home,
		  ...routes
		},
		meta:{
			title:"中南林业科技大学期刊社"
		}
	  },
	  {
	  		path: "/regist", 
	  		name: "regist",
			meta:{
				title:"注册页面"
			},
	  		components: {
	  		   default:regist,
	  		  ...routes
	  		}
	  },
	  {
	  		path: "/Nopassword", 
	  		name: "Nopassword",
	  		components: {
	  		   default:Nopassword,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"免密登录"
	  		}
	  },
	  {
	  		path: "/LookforPassword", 
	  		name: "LookforPassword",
	  		components: {
	  		   default:LookforPassword,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"密码找回"
	  		}
	  },
	  {
	  		path: "/Subscribe", 
	  		name: "Subscribe",
	  		components: {
	  		   default:Subscribe,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"Subscribe"
	  		}
	  },
	  {
	  		path: "/FixedBody", 
	  		name: "FixedBody",
	  		components: {
	  		   default:FixedBody,
	  		  ...routes
	  		}
	  },
	  {
		path: "/gzhFixedBody", 
		name: "gzhFixedBody",
		components: {
		   default:gzhFixedBody,
			footer: CommonFooter,
			banner:Banner,
			floatAd:floatAd,
			fixedImg:fixedImg
		   
		},
		meta:{
			title:""
		}
	  },
	  
	  {
		path: "/gzhNewsDetails", 
		name: "gzhNewsDetails",
		components: {
		   default:gzhNewsDetails,
			footer: CommonFooter,
			banner:Banner,
			floatAd:floatAd,
			fixedImg:fixedImg
		   
		},
		meta:{
			title:""
		}
	  },
	  {
	  		path: "/Situation", 
	  		name: "Situation",
	  		components: {
	  		   default:Situation,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"收录情况"
	  		}
	  },
	  {
	  		path: "/Export", 
	  		name: "Export",
	  		components: {
	  		   default:Export,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"文献导出"
	  		}
	  },
	  {
	  		path: "/OAList", 
	  		name: "OAList",
	  		components: {
	  		   default:OAList,
	  		  ...routes
	  		},
	  		meta:{
	  			title:""
	  		}
	  },
	  //公众号的最新一期/过刊目录
	  {
		path: "/gzhOAList", 
		name: "gzhOAList",
		components: {
		   default:gzhOAList,
			footer: CommonFooter,
			banner:Banner,
			floatAd:floatAd,
			fixedImg:fixedImg
		   
		},
		meta:{
			title:""
		}
},
	  {
	  		path: "/NewsList", 
	  		name: "NewsList",
	  		components: {
	  		   default:NewsList,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"通知公告"
	  		}
	  },
	  {
		path: "/gzhNewsList", 
		name: "gzhNewsList",
		components: {
		   default:gzhNewsList,
			footer: CommonFooter,
			banner:Banner,
			floatAd:floatAd,
			fixedImg:fixedImg
		   
		},
		meta:{
			title:""
		}
},
	  {
	  		path: "/NewsDetails", 
	  		name: "NewsDetails",
	  		components: {
	  		   default:NewsDetails,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"学报动态详情"
	  		}
	  },
	  {
	  		path: "/Links", 
	  		name: "Links",
	  		components: {
	  		   default:Links,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"友情链接"
	  		}
	  },
	  {
	  		path: "/Editorial", 
	  		name: "Editorial",
	  		components: {
	  		   default:Editorial,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"Editorial"
	  		}
	  },
	  {
	  		path: "/DownloadlistViewlist", 
	  		name: "DownloadlistViewlist",
	  		components: {
	  		   default:DownloadlistViewlist,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"下载排名"
	  		}
	  },
	  {
	  		path: "/dlistnum", 
	  		name: "dlistnum",
	  		components: {
	  		   default:dlistnum,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"过刊目录"
	  		}
	  },
	  {
		path: "/gzhdlistnum", 
		name: "gzhdlistnum",
		components: {
		   default:gzhdlistnum,
		   footer: CommonFooter,
		   banner:Banner,
		   floatAd:floatAd,
		   fixedImg:fixedImg
		},
		meta:{
			title:"过刊目录"
		}
},
//公众号推荐文章
{
	path: "/gzhRecommended", 
	name: "gzhRecommended",
	components: {
	   default:gzhRecommended,
	   footer: CommonFooter,
	   banner:Banner,
	   floatAd:floatAd,
	   fixedImg:fixedImg
	},
	meta:{
		title:"推荐文章"
	}
},
	  {
	  		path: "/digest", 
	  		name: "digest",
	  		components: {
	  		   default:digest,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"评论"
	  		}
	  },
	  {
	  		path: "/QuickSearch", 
	  		name: "QuickSearch",
	  		components: {
	  		   default:QuickSearch,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"简单搜索"
	  		}
	  },
	  {
	  		path: "/AdvancedSearch", 
	  		name: "AdvancedSearch",
	  		components: {
	  		   default:AdvancedSearch,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"高级搜索"
	  		}
	  },
	  {
	  		path: "/contact", 
	  		name: "contact",
	  		components: {
	  		   default:contact,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"contact"
	  		}
	  },
	  {
	  		path: "/comments", 
	  		name: "comments",
	  		components: {
	  		   default:comments,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"全部评论"
	  		}
	  },
	  {
	  		path: "/Login", //登录
	  		name: "Login",
	  		components: {
	  		   default:Login,
			   ...routes
	  		},
	  		meta:{
	  			title:"登录页面"
	  		}
	  },
	  {
	  		path: "/login_qq", //登录
	  		name: "login_qq",
	  		components: {
	  		   default:login_qq,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"qq登录页面"
	  		}
	  },
	  {
	    path: '/About',
	    name: 'About',
	    components: {
		  default: About,
		  ...routes
		},
		meta:{
			title:"学报简介"
		}
	  },
    {
      path: '/ScriptPrePrintDetailed',
      name: 'ScriptPrePrintDetailed',
      components: {
        default: ScriptPrePrintDetailed,
        ...routes
      },
	  meta:{
	  	title:"预出版"
	  }
    },
    {
      path: '/PreprintList',
      name: 'PreprintList',
      components: {
        default: PreprintList,
        ...routes
      },
	  meta:{
	  	title:"预出版"
	  }
	},
	{
		path: '/gzhPreprintList',
		name: 'gzhPreprintList',
		components: {
		  default: gzhPreprintList,
		  footer: CommonFooter,
			banner:Banner,
			floatAd:floatAd,
			fixedImg:fixedImg
		},
		meta:{
			title:"预出版"
		}
	  },
	  {
		path: '/DocumentList',
		name: 'DocumentList',
		components: {
		  default: DocumentList,
		  ...routes
		},
		
	  },
	  {
		path: '/FieldColumnList',
		name: 'FieldColumnList',
		components: {
		  default: FieldColumnList,
		  ...routes
		},
		meta:{
			title:""
		}
	  },
	  {
		path: "/gzhFieldColumnList", 
		name: "gzhFieldColumnList",
		components: {
		   default:gzhFieldColumnList,
		   footer: CommonFooter,
		   banner:Banner,
		   floatAd:floatAd,
		   fixedImg:fixedImg
		},
		meta:{
			title:"过刊目录"
		}
},
	  {
		path: "/Rss", 
		name: "Rss",
		components: {
		   default:Rss,
		  ...routes
		},
		meta:{
			title:"最新一期rss"
		}
	  },
	  
	  {
		path: "/DirectorAndFeatures", 
		name: "DirectorAndFeatures",
		components: {
		   default:DirectorAndFeatures,
		  ...routes
		},
	  },
	  {
		path: "/EamilVerification", 
		name: "EamilVerification",
		components: {
		   default:EamilVerification,
		},
		meta:{
			title:"邮箱验证"
		}
	  },
	  
	  {
		path: "/ChangePassword", 
		name: "ChangePassword",
		components: {
		   default:ChangePassword,
		},
		meta:{
			title:"密码修改"
		}
	  },
  ]
})
